/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { csoCustomerOrder } from '@/api/ajax';

export default [
  {
    id: 'taskDt',
    key: 'taskDt',
    width: 180,
    tip: '任务月度',
    label: '任务月度',
    format: 'yyyy-MM',
    slot: 'date'
  },
  {
    width: 140,
    id: 'createDate',
    label: '提交日期',
    required: false,
    slot: 'daterange',
    format: 'yyyy-MM-dd',
    key: 'createDate',
    text: ['提交日期起', '提交日期止']
    // key: ['createDateStart', 'createDateEnd']
  },
  {
    id: 'fullName',
    key: 'fullName',
    width: 180,
    tip: '项目参与人',
    label: '项目参与人',
    slot: 'input'
  },
  {
    id: 'payee',
    key: 'fullName',
    width: 180,
    tip: '收款方',
    label: '收款方',
    slot: 'input'
  },
  {
    id: 'phone',
    key: 'phone',
    width: 180,
    tip: '手机号',
    label: '手机号',
    slot: 'input'
  },
  {
    id: 'projectName',
    key: 'projectName',
    width: 180,
    tip: '项目名称',
    label: '项目名称',
    slot: 'input'
  },
  {
    width: 180,
    tip: '订单编号',
    label: '订单编号',
    key: 'orderNo',
    id: 'orderNo',
    slot: 'input'
  },
  {
    id: 'supplierId',
    key: 'supplierId',
    tip: '供应商',
    label: '供应商',
    required: false,
    slot: 'ajaxSelect',
    ajax: csoCustomerOrder.listSuppliers,
    prop: {
      label: 'supplierName',
      code: 'supplierId'
    },
    ajaxQuery: 'projectName',
    width: 'auto'
  },
  {
    id: 'payStatus',
    key: 'payStatus',
    tip: '支付状态',
    label: '支付状态',
    required: false,
    slot: 'select',
    clearable: true,
    options: [
      { name: '待支付', key: 0 },
      { name: '支付中', key: 1 },
      { name: '支付成功', key: 2 },
      { name: '支付失败', key: 3 },
      { name: '关闭支付', key: 100 },
      { name: '线下支付完成', key: 111 }
    ],
    width: 'auto'
  }
];
